import ActiveInActiveFilter from "../components/Filters/ActiveInActiveFilter";
import UnitsFilter from "../components/Filters/UnitsFilter";
import RegionsFilter from "../components/Filters/RegionsFilter";
import CategoryFilter from "../components/Filters/CategoryFilter";
import SubCategoryFilter from "../components/Filters/SubCategoryFilter";
import BrandFilter from "../components/Filters/BrandFilter";

const ProductFilters = ({
  onStatusFilterChange,
  currentStatusFilter,
  onRegionFilterChange,
  currentRegionFilter,
  onCategoryFilterChange,
  currentCategoryFilter,
  onSubCategoryFilterChange,
  currentSubCategoryFilter,
  showOnlyProductSubCategory,
  currentBrandFilter,
  onBrandFilterChange
}: {
  onStatusFilterChange: Function;
  onRegionFilterChange: Function;
  currentRegionFilter: any;
  currentStatusFilter: any;
  onCategoryFilterChange: Function;
  currentCategoryFilter: any;
  onSubCategoryFilterChange: Function;
  currentSubCategoryFilter: any;
  showOnlyProductSubCategory?:boolean
  onBrandFilterChange: Function,
  currentBrandFilter : any;
}) => {
  return (
    <>
      <RegionsFilter
        onRegionFilterChange={onRegionFilterChange}
        currentRegionFilter={currentRegionFilter}
        queryForAll="&showNeutral=false"
      />
       <BrandFilter
       isAccesory={false}
              onBrandFilterChange={onBrandFilterChange}
              currentBrandFilter={currentBrandFilter}
            />
      {/* <CategoryFilter
        onCategoryFilterChange={onCategoryFilterChange}
        currentCategoryFilter={currentCategoryFilter}
      /> */}
      <SubCategoryFilter
        onSubCategoryFilterChange={onSubCategoryFilterChange}
        currentSubCategoryFilter={currentSubCategoryFilter}
        showOnlyProductSubCategory={showOnlyProductSubCategory}
      />
      <ActiveInActiveFilter
        onStatusFilterChange={onStatusFilterChange}
        currentStatusFilter={currentStatusFilter}
      />
    </>
  );
};

export default ProductFilters;
